export const l_gallery_GridTemplateColumns_min = {
  "name": "--pf-v6-l-gallery--GridTemplateColumns--min",
  "value": "250px",
  "var": "var(--pf-v6-l-gallery--GridTemplateColumns--min)"
};
export default l_gallery_GridTemplateColumns_min;